import React from 'react'
import { Link } from 'react-router-dom'

export default function AppFormFooterBar({
  cancelPath,
  cancelLabel = 'Cancel',
  onCancel,
  showSaveAndContinue = false,
  continueLabel = 'Save & Continue',
  onSaveContinue,
  saveLabel = 'Save & Exit',
  onSaveExit,
  onSave,
  isSaving = false,
  className = '',
}) {
  const handleSave = onSaveExit || onSave

  return (
    <div
      className={`fixed bottom-0 left-0 lg:left-64 right-0 z-30 border-t border-outline-variant/20 bg-surface-container-lowest/90 backdrop-blur-md px-6 py-3.5 shadow-lg ${className}`}
    >
      <div className="mx-auto flex max-w-[1460px] items-center justify-end gap-3">
        {/* Cancel Button / Link */}
        {cancelPath ? (
          <Link
            to={cancelPath}
            className="rounded-xl border border-outline-variant/30 bg-surface-container-low px-5 py-2 text-xs font-bold text-on-surface-variant hover:bg-surface-container transition cursor-pointer text-center"
          >
            {cancelLabel}
          </Link>
        ) : onCancel ? (
          <button
            type="button"
            onClick={onCancel}
            className="rounded-xl border border-outline-variant/30 bg-surface-container-low px-5 py-2 text-xs font-bold text-on-surface-variant hover:bg-surface-container transition cursor-pointer text-center"
          >
            {cancelLabel}
          </button>
        ) : null}

        {/* Save & Continue Button */}
        {showSaveAndContinue && onSaveContinue && (
          <button
            type="button"
            disabled={isSaving}
            onClick={onSaveContinue}
            className="rounded-xl border border-primary/30 bg-primary/10 px-5 py-2 text-xs font-bold text-primary hover:bg-primary/20 transition disabled:opacity-50 cursor-pointer"
          >
            {continueLabel}
          </button>
        )}

        {/* Save & Exit / Save Button */}
        {handleSave && (
          <button
            type="button"
            disabled={isSaving}
            onClick={handleSave}
            className="inline-flex items-center gap-1.5 rounded-xl bg-primary px-6 py-2 text-xs font-bold text-on-primary shadow-sm hover:bg-primary/90 transition disabled:opacity-50 cursor-pointer"
          >
            {isSaving && (
              <span className="material-symbols-outlined animate-spin text-sm">progress_activity</span>
            )}
            <span>{isSaving ? 'Saving...' : saveLabel}</span>
          </button>
        )}
      </div>
    </div>
  )
}
